export default "/images/a711a85cea76250901966e1def2dea12.png";